<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row style="height: calc(100vh - 110px)!important ">
    <div class="top-line">
      <v-row>
        <v-col cols="4">
          <v-select
              :items="terminals"
              :item-text="terminal => terminal.name"
              :item-value="terminal => terminal.id"
              v-model="terminal"
              hide-details
              dense
              clearable
              label="Терминал"
              outlined
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-checkbox
              class="mt-2 pt-0"
              v-model="is_show_only_without_orders"
              label="Показать только без заказов"
          ></v-checkbox>
        </v-col>
      </v-row>

    </div>
    <v-col cols="12" sm="5" md="4" style="height: 100%; padding-top: 70px;">
      <div class="mb-4 search-col">
        <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
        ></v-text-field>
      </div>
      <div class="couriers-list" style="height: calc(100% - 48px); overflow-y: scroll">
        <v-expansion-panels v-model="selectedCourier">
          <v-expansion-panel
              v-for="(courier, index) in searchedCoordinates"
              :key="index"
              :id="courier.courierId"
          >
            <v-expansion-panel-header style="line-height: 1.4" @click="select(courier)" class="text-body-1">
              {{ courier.display_name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <table style="border: 1px solid #ccc; width: 100%; border-collapse: collapse;"
                     class="couriers-orders-list">
                <tr v-for="order in courier.orders" :key="order.id">
                  <td class="px-2 py-2" style="border-bottom: 1px solid #ccc">№{{ order.number }}</td>
                  <td class="px-2 py-2" style="border-bottom: 1px solid #ccc; white-space: nowrap">
                    {{ order.status === 'OnWay' ? 'В дороге' : order.status === 'Delivered' ? 'Доставлен' : order.status}}
                  </td>
                  <td class="px-2 py-2" style="border-bottom: 1px solid #ccc">
                    <div>{{ order.delivery_at }}</div>
                    <div>{{ order.address }}</div>
                  </td>
                </tr>
              </table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-col>
    <v-col cols="12" sm="7" md="8" style="padding-top: 70px;">
      <gmap-map
          :center="changingCenter"
          :zoom="changingZoom"
          ref="resizeMap1"
          style="width: 100%; height: 100%"
      >
        <gmap-cluster ref="cluster" :batch-size-i-e="2" :minimum-cluster-size="3">
          <gmap-marker v-for="(courier, index) in searchedCoordinates"
                       :position="{lat: courier.lastActiveLatitude, lng: courier.lastActiveLongitude}"
                       :clickable="true"
                       @click="handleMarkerClick(courier)"
                       :key="index"
                       :icon="index === selectedCourier ? 'http://maps.google.com/mapfiles/kml/paddle/orange-circle.png' : ''"
          ></gmap-marker>
        </gmap-cluster>
      </gmap-map>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import CourierService from "@/api/CourierService";
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import BranchService from "@/api/BranchService"; // replace src with dist if you have Babel issues

export default {
  name: 'CourierMap',
  components: {
    GmapCluster
  },
  data: () => ({
    changingCenter: {lat: 46.482952, lng: 30.712481},
    changingZoom: 11,
    search: '',
    coordinates: [],
    selectedCourier: null,
    selectedCourierId: null,
    interval: null,
    terminals: [],
    terminal: null,
    is_show_only_without_orders: false,
  }),
  beforeDestroy() {
    clearInterval(this.interval)
  },
  async mounted() {
    BranchService.terminalGroups().then(response => {
      this.terminals = response.data
    })

    this.update()

    this.interval = setInterval(() => this.update(), 60000);
  },
  watch: {
    terminal() {
      this.selectedCourier = null
    },
    search() {
      this.selectedCourier = null
    },
    is_show_only_without_orders() {
      this.selectedCourier = null
    }
  },
  methods: {
    async update() {
      const coordinates = await CourierService.listActiveCoordinated()

      this.coordinates = coordinates.data
      this.selectedCourier = this.searchedCoordinates.findIndex(item => item.courierId === this.selectedCourierId)
      this.$nextTick(() => {
        const element = document.getElementById(this.selectedCourierId);
        console.log(element)
        if (element) {
          element.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      });
    },
    handleMarkerClick(courier) {
      this.search = ''
      this.selectedCourier = this.searchedCoordinates.findIndex(item => item.courierId === courier.courierId)
      this.selectedCourierId = this.searchedCoordinates.find(item => item.courierId === courier.courierId).courierId
      console.log(this.selectedCourier)
      this.$nextTick(() => {
        const element = document.getElementById(courier.courierId);
        console.log(element)
        if (element) {
          element.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      });
    },
    select(courier) {
      this.changingZoom = 17

      this.$refs.resizeMap1.panTo({
        lat: courier.lastActiveLatitude,
        lng: courier.lastActiveLongitude
      })
      setTimeout(() => {
        this.$refs.cluster.$clusterObject.repaint();
        this.$refs.resizeMap1.$mapObject.setZoom(17);

      })
    }
  },
  computed: {
    searchedCoordinates() {
      let coordinates = this.coordinates

      if(this.search !== ''){
        coordinates = coordinates.filter(item => {
          return item.display_name.toLowerCase().includes(this.search);
        });
      }

      if(this.terminal){
        coordinates = coordinates.filter(item => {
          return item.terminal_group_id === this.terminal;
        });
      }

      if(this.is_show_only_without_orders){
        coordinates = coordinates.filter(item => {
          return item.orders.length === 0;
        });
      }

      return coordinates

    }
  }
}
</script>

<style lang="scss" scoped>
.top-line {
  position: absolute;
  top: 10px;
  left: 0;
  height: 60px;
  width: calc(100% - 12px);
}

.couriers-list {
  &::v-deep {
    .v-expansion-panel-header {
      justify-content: space-between;
    }

    .v-expansion-panel--active {
      border: 3px green solid;
    }
  }

  .couriers-orders-list {
    tr:hover {
      background-color: #eee;
    }
  }
}
</style>
